import React from 'react';
import styles from './Tag.module.scss';

const colors = [
  { Status: 'Super Admin', Color: '#264BE1' },
  { Status: 'Admin', Color: '#264BE1' },
  { Status: 'User Admin', Color: '#00A106' },
  { Status: 'Subscription Master', Color: '#8F26E1' },
  { Status: 'Resource Manager', Color: '#8F26E1' },

  { Status: 'User', Color: '#0095A1' },
  { Status: 'Data Analyst', Color: '#A14400' },
  { Status: 'Owner', Color: '#FFFFFF', backgroundColor: '#0744E1' },
];

const getStatusColor = (statusName) => {
  const normalizedStatusName = statusName?.trim()?.toLowerCase();
  const status = colors.find(
    (item) => item.Status?.trim().toLowerCase() === normalizedStatusName
  );
  return status ? status : { Color: '#000', backgroundColor: '#000' };
};

const Tag = ({ label, variant, isColored, className }) => {
  const { Color: textColor, backgroundColor } = getStatusColor(variant);

  const isOwner = variant?.toLowerCase() === 'owner';

  return (
    <span
      className={`${styles.tag} ${className ?? ''}`}
      style={{
        backgroundColor: isOwner ? backgroundColor : `${textColor}10`,
        color: textColor,
        border: variant == 'Owner' ? `none` : `1px solid ${textColor}`,
      }}
    >
      {label}
    </span>
  );
};

export default Tag;
